var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowUpdate)?_c('AppBanner',{staticClass:"text-center info"},[_c('p',{staticClass:"mb-0"},[_vm._v(" An update for this application is available. Please refresh your browser or "),_c('a',{staticClass:"link",on:{"click":_vm.updateApp}},[_vm._v("click here to update.")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }